module.exports = __webpack_public_path__ + "r-v3/img/whisper_white.9fe0cde4.svg";